import React from 'react'

const IcTimeRed = (props) => <svg {...props} width={15} height={16} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 0.5C3.36433 0.5 0 3.86433 0 8C0 12.1357 3.36433 15.5 7.5 15.5C11.6357 15.5 15 12.1357 15 8C15 3.86433 11.6357 0.5 7.5 0.5ZM11.0669 11.8793C10.945 12.0012 10.785 12.0625 10.625 12.0625C10.465 12.0625 10.3049 12.0012 10.1832 11.8793L7.05814 8.75439C6.94061 8.63755 6.87504 8.47871 6.87504 8.31254V4.25C6.87504 3.90439 7.15496 3.62504 7.5 3.62504C7.84504 3.62504 8.12496 3.90439 8.12496 4.25V8.05379L11.0669 10.9956C11.3112 11.2401 11.3112 11.635 11.0669 11.8793Z" fill="#FA8C8C" />
</svg>

export default IcTimeRed
